import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  "image-rendering": "optimizeQuality",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision",
  viewBox: "0 0 512 466.034"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M407.944 76.07c-10.427 14.04-21.175 28.936-25.608 36.762-11.17 19.56-38.573 22.838-39.743 14.409-.464-3.338 5.327-14.433 12.987-27.255 17.661-29.563 47.32-74.933 76.335-93.534C438.511 2.224 445-.346 450.804.038c4.445.293 7.708 2.788 9.367 8.266 15.214 39.597 31.854 74.427 50.414 102.835 1.346 2.421 1.695 4.619 1.203 6.631-1.64 6.713-15.648 12.587-21.59 14.458-8.554 2.694-13.591 1.685-18.339-5.18-9.347-13.517-16.23-29.002-22.912-44.55-7.208 111.916-54.801 204.034-126.755 269.945-79.605 72.921-188.991 113.678-306.386 113.59-6.723-.004-10.497-.577-13.313-4.081-2.543-3.164-2.712-7.142-2.349-14.119.564-10.815 2.624-16.829 9.196-20.81 5.621-3.403 13.818-4.254 27.424-5.081 4.014-.244 8.023-.617 12.038-.884 98.579-6.551 189.551-45.369 255.347-110.108 59.538-58.58 98.481-138.446 103.795-234.88" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "twisted-arrow-right-to-top-icon"}) } }